import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Footer from '../../Components/Footer/footer.component'
import CommonHeader from '../../Components/CommonHeader/common-header.component'
import imagebg from '../../assets/img/background__home.png'
import imageTransportSteps from '../../assets/img/background__transport.png'
import step1 from '../../assets/img/step1.png'
import step2 from '../../assets/img/step2.png'
import step3 from '../../assets/img/step3.png'
import step4 from '../../assets/img/step4.png'
import delivery from '../../assets/img/delivery.png'
import commande from '../../assets/img/commande.png'
import transporteur from '../../assets/img/transporteur.png'
import suivi from '../../assets/img/suivi.png'
import visibilite from '../../assets/img/visibilite.png'
import comptabilite from '../../assets/img/comptabilite2.png'
import transporteurs from '../../assets/img/transporteurs.png'
import './HomePage.css'
import { useTranslation } from 'react-i18next'
export default function HomePage() {
	const [typeCommande, setTypeCommande] = useState('mise-a-disposition')
	const [temporisation, setTemporisation] = useState('immediat')
	const history = useHistory()
    const { t } = useTranslation();
	const services = [
		{
			title: t("service1_title"),
			description: t("servie1_description"),
			image: commande,
		},
		{
			title:t("service2_title") ,
			description: t("service2_description"),
			image: transporteur,
		},
		{
			title: t("service3_title"),
			description: t("service3_description"),
			image: suivi,
		},
		{
			title:t("service4_title"),
			description: t("service4_description"),
			image: visibilite,
		},
		{
			title: t("service5_title"),
			description: t("service5_description"),
			image: comptabilite,
		},
	]
    
	return (
		<div>
			<CommonHeader />
			<div
				className='hero-section'
				style={{ backgroundImage: `url(${imagebg})` }}
			>
				<div className='hero-overlay'></div>
				<div className='hero-content'>
					<div className='hero-text'>
						<span className='brand-name-start'>B2BGLOB</span>
						<span className='brand-name-middle'> – </span>
						<span className='brand-name-end'>
							{t("slogan")}
						</span>
						<div className='hero-subtitle'>
							{t("slogan_subtitle")}
						</div>
					</div>
					<div className='order-box'>
						<div className='radio-group'>
							<label className='radio-label'>
								<input
									type='radio'
									name='type_commande'
									value='mise-a-disposition'
									checked={
										typeCommande === 'mise-a-disposition'
									}
									onChange={(e) =>
										setTypeCommande(e.target.value)
									}
								/>
								{t("mise_à_disposition")}
							</label>
						
						</div>
						<div className='separator'></div>
						<div className='radio-group'>
							<label className='radio-label'>
								<input
									type='radio'
									name='temporisation'
									value='immediat'
									checked={temporisation === 'immediat'}
									onChange={(e) =>
										setTemporisation(e.target.value)
									}
								/>
								{t("immédiate")}
							</label>
							<label className='radio-label'>
								<input
									type='radio'
									name='temporisation'
									value='planifie'
									checked={temporisation === 'planifie'}
									onChange={(e) =>
										setTemporisation(e.target.value)
									}
								/>
								{t("planifiée")}
							</label>
						</div>
						<button
							onClick={() =>
								history.push(
									`/passer-commande?type_commande=${typeCommande}&temporisation=${temporisation}`
								)
							}
							className='order-button'
						>
							{t("commander")}
						</button>
					</div>
				</div>
			</div>

			<div
				className='steps-section'
				style={{ backgroundImage: `url(${imageTransportSteps})` }}
			>
				<h2 className='section-subtitle-blue'> {t("functioning_subtitle")} </h2>
				<p className='section-title-dark'>
					{t("functioning")}
				</p>
				<div className='steps-container'>
					<div className='step'>
						<img
							src={step1}
							alt='Créer une commande'
							className='step-image'
						/>
						<p className='step-description'>
							{t("step1")}
						</p>
					</div>
					<div className='step'>
						<img
							src={step2}
							alt='Transporteur adéquat'
							className='step-image'
						/>
						<p className='step-description'>
							{t("step2")}
						</p>
					</div>
					<div className='step'>
						<img
							src={step3}
							alt='Chargement des marchandises'
							className='step-image'
						/>
						<p className='step-description'>
							{t("step3")}
						</p>
					</div>
					<div className='step'>
						<img
							src={step4}
							alt='Confirmation de fin'
							className='step-image'
						/>
						<p className='step-description'>
							{t("step4")}
						</p>
					</div>
				</div>
			</div>

			<div className='about-us-section'>
				<div className='about-us-container'>
					<div className='about-us-text-left'>
						<h2 className='section-subtitle-blue'>
							{t("entreprise")}
						</h2>
						<h3 className='section-title-dark-left'>
							{t("who_we_are")}
						</h3>
						<p className='section-paragraph'>
							{t("entreprise_history")}
						</p>
					</div>
					<div className='about-us-image-container'>
						<img
							src={delivery}
							alt='Livreur'
							className='about-us-image'
						/>
						<div className='satisfied-clients-box'>
							<p className='satisfied-clients-number'>1480+</p>
							<p>{t("satisfied_clients")}</p>
						</div>
					</div>
					<div className='about-us-text-right'>
						<p className='section-paragraph'>
							{t("entreprise_goal")}
						</p>
						<p className='section-paragraph'>
							{t("introduce_b2bglob")}
						</p>
						<button
							onClick={() => history.push('/CreateAccount')}
							className='create-account-button'
						>
							{t("create_account")}
						</button>
					</div>
				</div>
			</div>

			<div className='services-section'>
				<h2 className='section-title-blue-center'> {t("service")} </h2>
				<p className='section-paragraph-center'>
					{t("discover")}
				</p>
				<div className='services-container'>
					{services.map((service, index) => (
						<div className='service-card' key={index}>
							<img
								src={service.image}
								alt={service.title}
								className='service-image'
							/>
							<h3 className='service-title'>{service.title}</h3>
							<p className='service-description'>
								{service.description}
							</p>
						</div>
					))}
				</div>
			</div>

			<div className='for-business-section'>
				<div className='for-business-container'>
					<div className='for-business-text'>
						<h1 className='for-business-title'>
							{t("b2b_for_businesse_title")}
						</h1>
						<p className='section-paragraph'>
							{t("b2b_for_business_paragraph")}
						</p>
						<ul className='for-business-list'>
							<li>
								{t("b2b_for_business1")}
							</li>
							<li>
								{t("b2b_for_business2")}
							</li>
							<li>
								{t("b2b_for_business3")}
							</li>
						</ul>
						<button
							onClick={() => history.push('/CreateAccount')}
							className='create-account-button'
						>
							{t("create_account")}
						</button>
					</div>
					<div className='for-business-image-container'>
						<img
							src={transporteurs}
							alt='Transporteurs'
							className='for-business-image'
						/>
						<div className='for-business-image-overlay'></div>
					</div>
				</div>
			</div>

			<Footer />
		</div>
	)
}
